import {Component} from '@angular/core';

import {AlertaModel} from '../Modelo/Alerta.model';
import {MensajeService} from '../Mensaje.Service';
import {AlertaEnum} from '../Enumeraciones/MensajeEnumeraciones.enum';
import {Dialogo} from '../Modelo/Dialogo.model';


@Component(
  {
    selector: 'alertaTimer',
    templateUrl: './AlertaTimer.template.html',
    styleUrls: ['./AlertaTimer.scss'],
  })

export class AlertaTimerComponent
{
  alerta: AlertaModel = new AlertaModel();

  timer : any;
  descripcionBase : string = "";
  finTimer : any;
  abierto :boolean = false;

  constructor(private mensajeService: MensajeService)
  {
  }

  ngOnInit()
  {
    this.mensajeService.IniciarAlertaTimer().subscribe((alerta: AlertaModel) =>
    {
      this.alerta = alerta;
      this.SetDatosAlerta(this.alerta);
    });
  }

  SetDatosAlerta(alerta : AlertaModel)
  {
    switch (alerta.Tipo)
    {
      case AlertaEnum.Success:
        alerta.Icono = "fa fa-check";
        alerta.Clase = "success"
        break;

      case AlertaEnum.Warning:
        alerta.Icono = "fa fa-exclamation-triangle";
        alerta.Clase = "warning"
        break;

      case AlertaEnum.Error:
        alerta.Icono = "fa fa-exclamation-triangle";
        alerta.Clase = "error"
        break;

      case AlertaEnum.Informacion:
        alerta.Icono = "fa fa-info";
        alerta.Clase = "informacion"
        break;

      default:
        break;
    }

    alerta.Animacion = "slideInUp";

    this.StartTimer(alerta);
  }

  DesplegarAlerta()
  {
    this.abierto = true;;
  }

  CerrarAlerta()
  {
    this.alerta.Animacion = "slideOutDown rapido";
    this.abierto = false;
    this.alerta = new AlertaModel();
  }

  CancelarAlerta()
  {
    clearInterval(this.timer);
    this.timer = null;
    this.CerrarAlerta();
    this.mensajeService.TerminarAlerta(false);
  }

  StartTimer(alerta : AlertaModel)
  {
    this.descripcionBase = alerta.Descripcion;
    this.finTimer = new Date();
    this.finTimer.setSeconds(this.finTimer.getSeconds() + (alerta.Tiempo));

    alerta.Descripcion = this.descripcionBase.replace("{Tiempo}", alerta.Tiempo.toString());

    this.timer = setInterval(() =>
    {
      var tiempo = this.DifenciaTiempo(this.finTimer, alerta);
      alerta.Descripcion = this.descripcionBase.replace("{Tiempo}", tiempo.toString());
    }, 1000);

    this.DesplegarAlerta();
  }

  DifenciaTiempo(termina : any, alerta : AlertaModel)
  {
    var dateEntered = termina;
    var now = new Date();
    var difference = dateEntered.getTime() - now.getTime();

    if (difference <= 0)
    {
      clearInterval(this.timer);
      this.timer = null;
      this.CerrarAlerta();
      this.mensajeService.TerminarAlerta(true);
      return 0;
    }
    else
    {
      var segundos = Math.ceil(difference / 1000);
      var minutos = Math.floor(segundos / 60);

      return segundos;
    }
  }
}
